import React, { useContext } from "react";
// router, intl
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
// ui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import classNames from "classnames";
// component
import { StoreContext } from "../../../../../store/StoreProvider";
import NodeCountFilter from "./nodeCountFilter/NodeCountFilter";
import LinkCountFilter from "./linkCountFilter/LinkCountFilter";
// import NodeCountDef from "./nodeCountDef/NodeCountDef";
import NodeCountDefNew from "./nodeCountDefNew/NodeCountDefNew";
import LimitTotalNodesFilter from "./limitTotalNodesFilter/LimitTotalNodesFilter";
import BottomPanel from "./bottomPanel/BottomPanel";
import TimeFilter from "./timeFilter/TimeFilter";
import NodeAuthorFilter from "./nodeAuthorFilter/NodeAuthorFilter";
import EventTypeFilter from "./eventTypeFilter/EventTypeFilter";
// hook
import useLocaleRoute from "../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../hooks/useModulePublic";
// config,utils,css
import fireAuth from "../../../../../api/firebase/auth/utils";
import urls from "../../../../../api/project/ApiUrls";

//
const FilterTool = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  //
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { filter } = sna;
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);
  // const isLoggedIn = true;

  return (
    <Box>
      <Box pb={2}>
        <Typography
          textAlign="left"
          variant="body1"
          sx={{
            color: "#fff",
          }}
          className={classNames(
            "sna-sidebar__title",
            "sna-sidebar__title--filter-tool"
          )}
        >
          {intl.formatMessage({
            id: "sna.sidebar.filtertool.title",
            defaultMessage: "篩選",
          })}
        </Typography>
      </Box>
      <NodeAuthorFilter />
      <LimitTotalNodesFilter />
      <NodeCountFilter />
      <LinkCountFilter />
      <TimeFilter />
      {/* <NodeCountDef /> */}
      <NodeCountDefNew />
      <EventTypeFilter />
      <BottomPanel />
    </Box>
  );
};

export default FilterTool;
